export default data => data.filter(el => el.module !== 3);
